import React, { useState } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import chemical from "../../../../../assets/images/OUR SERVICES/6. Cleaning Chemicals.png";
import EnquiryModal from '../../../../../common/pages/enquiryModal';
const CleaningChemicals = () => {
    const [modal, setModal] = useState(false);
    const toggleModal = () => setModal(!modal);
    return (
        <React.Fragment>

            <section className="section bg-light py-5" id="features">
                <Container>
                    <Row className="align-items-center gy-4">
                        <div className="text-muted">
                            <div className="text-center ">
                                <h2 className="fw-bold mt-5" style={{ fontSize: "2rem", color: "#F15A29" }}>Cleaning Chemicals</h2>

                            </div>
                        </div>
                    </Row>
                </Container>
            </section>

            <section className="section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={10} sm={10}>
                            <Row className="align-items-center gy-4">

                                <Col lg={6} md={12}>
                                    <img
                                        src={chemical}
                                        alt="Cleaning Chemicals"
                                        className="img-fluid rounded"
                                        style={{ width: "100%", height: "auto" }}
                                    />
                                </Col>
                                <Col lg={6} md={12}>
                                    <div className="text-black">
                                        <p><strong>Disinfectants & Sanitizers</strong> – Powerful and effective solutions designed to eliminate germs, bacteria, and viruses, ensuring a hygienic and safe environment in workplaces, hospitals, and public spaces.</p>
                                        <p><strong>Glass Cleaners</strong> – Streak-free formulations that provide a sparkling shine on windows, mirrors, and glass surfaces, removing dust, fingerprints, and smudges with ease.</p>
                                        <p><strong>Floor Cleaners</strong> – Deep-cleaning solutions suitable for various flooring types, including tiles, wood, and marble, leaving surfaces spotless and fresh-smelling.</p>
                                        <p><strong>Bathroom Cleaners</strong> – Specialized cleaning formulas designed to remove tough stains, soap scum, and odors from toilets, sinks, and tiles, ensuring a fresh and germ-free washroom.</p>
                                        <p><strong>Multipurpose Cleaners</strong> – Versatile and highly effective solutions for cleaning multiple surfaces, including countertops, appliances, furniture, and more, making everyday cleaning effortless.</p>
                                    </div>
                                </Col>

                            </Row>
                        </Col>
                    </Row>
                </Container>
                <EnquiryModal isOpen={modal} toggle={toggleModal} />
            </section>
            <section className="section  py-5" style={{ backgroundColor: " rgb(52, 81, 159)" }} id="features">
                <Container>
                    <Row className="justify-content-center">
                        <div className='text-center '>
                            <Button className='px-4 py-2 fw-bold' onClick={toggleModal}
                                style={{ background: "rgb(238, 99, 82)", borderRadius: "20px", color: "white", fontSize: "20px" }}
                            >
                                Enquiry Now
                            </Button>
                        </div>
                    </Row>
                </Container>
            </section>
        </React.Fragment >
    );
};

export default CleaningChemicals;